// Module
var code = "<td name=loadingStopSequence>{{ record.value[0].deliveryUnitData.loadingStopSequence + 1 }}</td> <td name=quantity>{{ getRemainingQuantity(record) }}</td> <td name=shipmentUnitProductQuantity>{{ getRemainingProductQuantity(record) }}</td> <td name=loadingLocality>{{ record.value[0].deliveryUnitData.loadingLocality | entityFormat }}</td> ";
// Exports
module.exports = code;